'use strict'

import React, { Fragment, memo, useState } from 'react'
import ClipboardJS from 'clipboard'
import uuid4 from 'uuid4'
import $ from 'jquery'
import 'popper.js/dist/popper.min.js'
import 'bootstrap/js/dist/tooltip.js'

import '../assets/styles/button.scss'
import '../assets/styles/tooltip.scss'
import copySvg from '../assets/img/copy.svg'
import downloadSvg from '../assets/img/download.svg'
import refreshSvg from '../assets/img/refresh.svg'

const Actions = () => {
  const [uuid, setUUID] = useState(uuid4())
  const [clipboard, setClipboard] = useState(null)
  if (!clipboard) {
    setClipboard(new ClipboardJS('#copy-id'))
  }

  const copyToClipboardStatus = show => {
    if (show) {
      $('#copy-id').tooltip('enable')
      $('#copy-id').tooltip('show')
    } else {
      $('#copy-id').tooltip('disable')
    }
  }

  const downloadUUIDs = e => {
    e.preventDefault()
    let ids = []
    for (let i = 0; i < 100; i++) {
      ids.push(uuid4())
    }

    const text = ids.join('\n')
    const currentDate = new Date()

    let element = document.createElement('a')
    element.setAttribute(
      'href',
      `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`
    )

    element.setAttribute('download', `uuid4-${currentDate.getTime()}.txt`)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  return (
    <Fragment>
      <section className='row justify-content-center my-5 py-1'>
        <div className='col'>
          <h2 className='id text-center'>{uuid}</h2>
        </div>
      </section>
      <section className='row justify-content-center my-5 py-1'>
        <div className='col text-center'>
          <button
            type='button'
            className='btn'
            id='copy-id'
            onClick={copyToClipboardStatus}
            onMouseEnter={() => copyToClipboardStatus(false)}
            onMouseLeave={() => copyToClipboardStatus(false)}
            data-clipboard-text={uuid}
            data-toggle='tooltip'
            data-placement='bottom'
            title='Copied!'
            style={{ display: 'inline-block' }}
          >
            <img src={copySvg} alt='Copy uuid to clipboard' width='45px' />
          </button>
          <button
            type='button'
            className='btn'
            onClick={() => setUUID(uuid4())}
          >
            <img src={refreshSvg} alt='Refresh uuid' width='45px' />
          </button>
          <button type='button' className='btn' onClick={downloadUUIDs}>
            <img src={downloadSvg} alt='Download 100 uuids' width='45px' />
          </button>
        </div>
      </section>
    </Fragment>
  )
}

export default memo(Actions)
